<template>
  <div class="user-avatar-dailog dialog col-block">
    <div class="user-avatar-container col-block flex-start">
      <div class="user-avatar-title">{{ 'Select a avatar from default set or upload from drive'/* ___ */ }}</div>
      <div :style="{ height: '10px' }"></div>
      <div class="user-avatar-list-container row-block flex-start flex-wrap">
        <div class="user-avatar-block" v-for="(avatar, index) in avatars" :key="index" @click="e => selectedID = avatar.id">
          <div class="user-avatar" :style="{ 'background-image': 'url(' + avatar.url + ')' }"></div>
          <div class="user-avatar-radio-icon icon-block" :style="{ '--size': '20px' }">
            <img :src="selectedID === avatar.id ? require('../../assets/images/radio-true.svg') : require('../../assets/images/radio-false.svg')" alt="">
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="custom-avatar-container col-block flex-start">
      <div class="custom-avatar-title-container row-block" :class="{ disabled: !customAvatar }" @click="e => customAvatar && (selectedID = 'custom')">
        <div class="custom-avatar-radio-icon icon-block" :style="{ '--size': '20px' }">
          <img :src="selectedID === 'custom' ? require('../../assets/images/radio-true.svg') : require('../../assets/images/radio-false.svg')" alt="">
        </div>
        <div :style="{ width: '10px' }"></div>
        <div class="custom-avatar-title">{{ 'Custom avatar'/* ___ */ }}</div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="custom-avatar-main-container col-block">
        <div v-if="customAvatar" class="custom-avatar-image-block">
          <div class="custom-avatar-image mask" :style="{ 'background-image': 'url(' + customAvatar.url + ')' }"></div>
          <div class="custom-avatar-image" :style="{ 'background-image': 'url(' + customAvatar.url + ')' }"></div>
        </div>
        <div class="mask">
          <input v-show="false" type="file" id="custom-avatar" accept="image/*" @change="e => fileTypeCheck(e, e => selectCustomAvatar(e), () => addToast('error', 'Please upload image file'/* ___ */))">
          <label for="custom-avatar"></label>
          <button class="white-gray-button circle-button">
            <span>{{ 'Select'/* ___ */ }}</span>
          </button>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Cancel'/* ___ */ }}</span>
      </button>
      <div :style="{ width: '16px' }"></div>
      <button class="main-button circle-button" @click="e => setAvatar()">
        <span>{{ 'Upload'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { API_ROOT } from '../../api/config'
import { getUserAvatarFile, getUserAvatarFiles } from '../../api'
import toastMethods from '../../mixins/toastMethods'
import routeLoading from '../../mixins/routeLoading'
import { fileTypeCheck, imageReader } from '../../constants/global/util'

export default {
  mixins: [
    toastMethods,
    routeLoading
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedID: null,
      avatars: [],
      customAvatar: null
    }
  },
  computed: {
    ...mapGetters([
      'userSetting'
    ]),
    // param
    defaultAvatar () {
      return this.param.avatar || {}
    },
    // global
    fileTypeCheck () { return fileTypeCheck }
  },
  methods: {
    ...mapActions([
      'setUserSettingAction',
      'setModal2Action'
    ]),
    async fetchData () {
      await this.fetchCustomAvatar()
      await this.fetchUserAvatarFiles()
    },
    async fetchCustomAvatar () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getUserAvatarFile(config)
        let customAvatar = response.data.data
        if (customAvatar) {
          this.customAvatar = {
            ...customAvatar,
            url: API_ROOT + 'global/files/download?file_id=' + customAvatar.id + '&class_name=' + customAvatar.class_name + '&access_token=' + config['access_token']
          }
        }
      } catch (error) {
        throw error
      }
    },
    async fetchUserAvatarFiles () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getUserAvatarFiles(config)
        let avatars = response.data.data
        avatars = avatars.filter(avatar => avatar.size && (avatar.id !== (this.customAvatar || {}).id)).map(avatar => ({
          ...avatar,
          url: API_ROOT + 'global/files/download?file_id=' + avatar.id + '&class_name=' + avatar.class_name + '&access_token=' + config['access_token']
        }))
        this.avatars = avatars
      } catch (error) {
        throw error
      }
    },
    async afterSetData () {
      let id = this.defaultAvatar.id || this.userSetting.avatar_file.id
      this.selectedID = (this.avatars.find(avatar => avatar.id === id) || {}).id || 'custom'
      this.customAvatar = ((this.defaultAvatar.id || '') === 'custom') ? this.defaultAvatar : this.customAvatar
    },
    async selectCustomAvatar (e) {
      let file = e.target.files[0]
      let url = (await imageReader([file]))[0]
      this.setModal2Action({
        action: 'imageCropper',
        width: '616px',
        param: {
          url: url
        },
        callback: async result => {
          if (result) {
            this.customAvatar = {
              id: 'custom',
              name: file.name,
              url: result.url,
              file: result.file,
              class_name: 'AvatarFile'
            }
          }
        }
      })
      e.target.value = ''
    },
    async setAvatar () {
      let result = this.avatars.find(avatar => avatar.id === this.selectedID) || this.customAvatar
      this.$emit('changeModal', {}, result)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/userAvatar.vue